import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";

// 請求者区分が退職者本人の場合
const retireeStepper = [
  "退職者確認",
  "請求者の確認",
  "請求者情報の登録",
  "振込先金融機関の登録",
  "本人確認の書類の添付",
  "退職所得の受給に関する申告書の登録",
  "源泉徴収票の確認",
  "申告書兼退職所得申告書の作成",
  "退職所得情報登録",
  "登録内容の確認",
  "機構へ提出",
];

// 請求者区分が相続人の場合
const heirStepper = [
  "退職者確認",
  "請求者の確認",
  "請求者情報の登録",
  "振込先金融機関の登録",
  "受給権者確認添付書類",
  "本人確認の書類の添付",
  "退職所得の受給に関する申告書の登録",
  "源泉徴収票の確認",
  "申告書兼退職所得申告書の作成",
  "退職所得情報登録",
  "登録内容の確認",
  "機構へ提出",
];

const info = (
  <div className="info">
    ■源泉徴収票の確認
    <br />　<u>福祉医療機構以外から退職手当金が支給されている場合</u>
    、勤務先の法人から当該退職金制度にかかる源泉徴収票が登録されています。
    <br />
    　登録されている場合は、内容を確認いただき、それ以外に退職手当金が支払われている場合は、「源泉徴収票を追加で添付」ボタンを押して、
    源泉徴収票添付とその内容の入力を行ってください。
    <br />
    　全て登録されている場合、または、機構以外からの退職金の支給がない場合は、「全て登録されていることを確認」ボタンを押して次に進んでください。
    <br />
    　※
    <a
      href={`${
        process.env.PUBLIC_URL ?? ""
      }/assets/pdf/≪別紙≫退職所得の源泉徴収票.pdf`}
      target="_blank"
      rel="noreferrer"
    >
      退職所得の源泉徴収票
    </a>
    の登録は、所得税第２０３条第１項及び所得税法基本解釈通達２０１ー１に基づく福祉医療機構への通報書として登録をいただくものです。
    <br />
    　※
    <a
      href={`${
        process.env.PUBLIC_URL ?? ""
      }/assets/pdf/≪別紙≫給与所得の源泉徴収票.pdf`}
      target="_blank"
      rel="noreferrer"
    >
      給与所得の源泉徴収票
    </a>
    は不要です。添付しないでください。
  </div>
);

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "法人が添付した源泉徴収票（1枚目）",
    keyword: "corporationAttachedFile1",
    type: "downloadLink",
    helpicon: true,
    helpText: "機構以外から支給された退職金の源泉徴収票です",
    showLine: false,
    downloadBase64: true,
  },
  {
    title: "法人が添付した源泉徴収票（2枚目）",
    keyword: "corporationAttachedFile2",
    type: "downloadLink",
    helpicon: true,
    helpText: "機構以外から支給された退職金の源泉徴収票です",
    showLine: false,
    downloadBase64: true,
  },
  {
    title: "法人が添付した源泉徴収票（3枚目）",
    keyword: "corporationAttachedFile3",
    type: "downloadLink",
    helpicon: true,
    helpText: "機構以外から支給された退職金の源泉徴収票です",
    showLine: false,
    downloadBase64: true,
  },
  {
    title: "源泉徴収票（1枚目）",
    keyword: "retirementIncomeFile1",
    type: "nodeInLine",
    helpicon: true,
    helpText: "機構以外から支給された退職金の源泉徴収票です",
    showLine: false,
  },
  {
    title: "源泉徴収票（2枚目）",
    keyword: "retirementIncomeFile2",
    type: "nodeInLine",
    helpicon: true,
    helpText: "機構以外から支給された退職金の源泉徴収票です",
    showLine: false,
  },
];

export { info, retireeStepper, heirStepper, fakeTableList };
